import EyeOpen from './eye_open.svg'
import EyeClosed from './eye_closed.svg'

export const icons = {
  EyeOpen,
  EyeClosed,
}
